import BasicLink from "app/components/basic/Link";
import "./styles.scss";
import { ChevronRightIcon } from "@lifesg/react-icons/chevron-right";

interface IProps {
	text: string | JSX.Element;
	link?: [string, string];
	className?: string;
}

const ButtonIcon = (props: any): JSX.Element => <ChevronRightIcon className={props.className} />;

const SideBox = (props: IProps): JSX.Element => (
	<div className={`sidebox ${props.className ?? ""}`}>
		<div className="sidebox__text">{props.text}</div>
		{props.link && (
			<div className="mt16 sidebox__action">
				<BasicLink name={props.link[0]} id="btn-find-a-service" href={props.link[1]} IconRight={ButtonIcon} />
			</div>
		)}
	</div>
);

export default SideBox;
